import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { BodyCell, IBodyCell } from '../../holders/body-cell.component';
import { TextCell } from '../text/text.component';

@Component({
   selector: 'exi-text-array',
   template: `
      <exi-text   *ngFor="let text of array"
                  [value]="text"
                  [cell]="textCell"
                  class="text"
                  [ngStyle]="style"></exi-text>
   `,
   styleUrls: ['./text-array.component.scss']
})
export class TextArrayCellComponent<D> implements IBodyCell<D>, OnInit {
   @Input() cell: TextArrayCell<D>;
   @Input() value: D;
   public array: string[];
   public textCell = new TextCell<string>(text => text);
   private dom: HTMLDivElement;

   public style: object = {};

   constructor(
      private domRef: ElementRef
   ) {}

   ngOnInit() {
      this.dom = this.domRef.nativeElement;
      this.array = this.cell.get(this.value);
      this.setSizes();
   }

   private setSizes() {
      const size = 100 / this.array.length;

      switch (this.cell.orient) {
         case 'vert': 
            this.style['height.%'] = size; 
            this.dom.style.flexDirection = 'column';
         break;
         case 'horiz':
            this.style['width.%'] = size; 
            this.dom.style.flexDirection = 'row';
         break;
      }
   }
}

export class TextArrayCell<D> extends BodyCell<D> {
   constructor(
      public get: (row: D) => string[],
      public orient: 'horiz' | 'vert' = 'vert',
   ) {
      super(TextArrayCellComponent, value => get(value).join(', '));
   }
}
